import { motion } from "framer-motion";
import { MaskedLines, Eyebrow, EASE } from "./motion";

export default function PageHero({ eyebrow, lines, description, image, short = false, logoOnDark, logoOnLight, children }) {
  return (
    <section
      className={`relative flex items-end overflow-hidden bg-ink ${short ? "min-h-[62vh]" : "min-h-[82vh]"}`}
      aria-label={lines.join(" ")}
    >
      <div className="absolute inset-0">
        <img src={image} alt="" className="kenburns h-full w-full object-cover opacity-40" />
        <div className="ambient-layer opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/30" />
      </div>
      <div className="relative z-10 w-full px-6 pb-20 pt-44 lg:px-12">
        {logoOnDark && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05, duration: 0.7 }}
            className="mb-10"
          >
            <img src={logoOnDark} alt="" className="only-dark-theme h-9 w-auto lg:h-12" />
            <img src={logoOnLight} alt="" className="only-light-theme h-9 w-auto lg:h-12" />
          </motion.div>
        )}
        {eyebrow && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1, duration: 0.8 }}>
            <Eyebrow>{eyebrow}</Eyebrow>
          </motion.div>
        )}
        <MaskedLines
          as="h1"
          lines={lines}
          delay={0.2}
          className="mt-5 max-w-5xl text-5xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-6xl lg:text-8xl"
        />
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8, ease: EASE }}
            className="mt-6 max-w-2xl text-base leading-loose text-smoke md:text-lg"
          >
            {description}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.75, duration: 0.8, ease: EASE }}
            className="mt-8"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
